import type { MeetingActionItem } from "../../../api/meetingsApi";
import { ACTION_STATUS_LABELS } from "../constants";

type Props = {
  actions?: MeetingActionItem[];
  onVerify: (actionId: string) => void;
  onRefresh?: () => void;
};

export function PreviousActionsBanner({ actions = [], onVerify, onRefresh }: Props) {
  if (!actions.length) return null;
  return (
    <div className="tm-banner">
      <div>
        <strong>{actions.length} משימות מהישיבה הקודמת</strong> טרם אושרו כטופלו — סמן לפני
        תחילת הסיכום
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
          marginTop: 12,
          width: "100%",
        }}
      >
        {actions.map((a) => (
          <div key={a.id} className="tm-agenda-item" style={{ background: "var(--ck-surface)" }}>
            <div className="tm-agenda-item__body">
              <div className="tm-agenda-item__title">{a.description}</div>
              <div className="tm-agenda-item__meta">
                {a.assignedToName ? `אחראי: ${a.assignedToName} · ` : ""}
                {ACTION_STATUS_LABELS[a.status || ""] || a.status}
              </div>
            </div>
            <button
              type="button"
              className="tm-btn tm-btn--primary tm-btn--sm"
              onClick={() => onVerify(a.id)}
            >
              סומן כטופל
            </button>
          </div>
        ))}
      </div>
      {onRefresh ? (
        <button
          type="button"
          className="tm-btn tm-btn--ghost tm-btn--sm"
          onClick={onRefresh}
          style={{ marginTop: 8 }}
        >
          רענן
        </button>
      ) : null}
    </div>
  );
}
